import { useEffect, useRef } from "react";

const getDefaultItemId = (item) => item?.id;

const useInitialPreviewSelection = ({
  isOpen,
  isReady,
  previewId,
  items = [],
  getId = getDefaultItemId,
  onSelect,
  onConsume = () => {},
  allItems,
  onHidden,
}) => {
  const openedPreviewIdRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      openedPreviewIdRef.current = null;
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen || !isReady || !previewId) {
      return;
    }

    const id = String(previewId);
    const existingIndex = items.findIndex(
      (entry) => String(getId(entry) ?? "") === id
    );

    if (existingIndex >= 0) {
      if (openedPreviewIdRef.current === id) {
        return;
      }

      openedPreviewIdRef.current = id;
      onSelect({ index: existingIndex, item: items[existingIndex] });
      onConsume();
      return;
    }

    const isHidden =
      Array.isArray(allItems) &&
      typeof onHidden === "function" &&
      allItems.some((entry) => String(getId(entry) ?? "") === id);

    if (isHidden) {
      onHidden();
      return;
    }

    if (openedPreviewIdRef.current === id) {
      return;
    }

    openedPreviewIdRef.current = id;
    onConsume();
  }, [
    allItems,
    getId,
    isOpen,
    isReady,
    items,
    onConsume,
    onHidden,
    onSelect,
    previewId,
  ]);
};

export default useInitialPreviewSelection;
